export type UseCaseValue =
  | 'tech_scouting'
  | 'competitive_intelligence'
  | 'business_development'
  | 'investment'
  | 'government_acquisition'
  | 'research_science'
  | 'other'
  // Legacy values (still emitted by old tech vectors; normalized on the backend).
  // business_intel + landscape_analysis -> competitive_intelligence
  // grant_matching -> research_science
  | 'business_intel'
  | 'landscape_analysis'
  | 'grant_matching';
export type Scope = 'broad' | 'balanced' | 'targeted';
export type ReasoningEffort = 'low' | 'medium' | 'high';
export type ResearchEffort = 'standard' | 'deep';
export type SearchStrategy = 'fast' | 'balanced' | 'thorough';


// TODO: replace these with enums from Database when we change module_key and dataset_keys back to enums (instead of strings) in postgres
export enum TvModuleKey {
  GEN_TOPICS = 'gen_topics',
  // SEARCH_FROM_TOPICS = 'search_from_topics',
  GEN_TV_FROM_TOPICS = 'gen_tv_from_topics',
  // Optional, self-contained AI insights module (owns tv_synthesis / topic_synthesis).
  GEN_TV_INSIGHTS = 'gen_tv_insights',
  MINE_NEWS = 'mine_news',
  // MINE_WIKIPEDIA = 'mine_wikipedia',
  // DOCUMENT_AGGREGATOR = 'document_aggregator',
  // REPORT_GENERATOR = 'report_generator',
  // CONTRACTS = 'contracts',
  GEN_TV_TECH_CARD = "gen_tv_tech_card",
  GEN_REPORT_PDF = 'gen_report_pdf',
  GEN_TV_REPORT = 'gen_tv_report',
  GEN_TV_CUSTOM_REPORT = 'gen_tv_custom_report',
  // BUDGET_TECHS = 'budget_techs',
}



export enum TvDataset {
  TOPICS = 'topics',
  TOPIC_SEARCH_CONFIGS = 'topic_search_configs',
  DOC_EMBEDDINGS = 'doc_embeddings',
  PATENTS = 'patents',
  PUBS = 'pubs',
  GRANTS = 'grants',
  CONTRACTS = 'contracts',
  STARTUPS = 'startups',
  WIKIPEDIA = 'wikipedia',
  NEWS = 'news',
  ORG_RANKINGS = 'org_rankings',
  COUNTRY_RANKINGS = 'country_rankings',
  SME_RANKINGS = 'sme_rankings',
  TOPIC_RANKINGS = 'topic_rankings',
  OVERVIEW_METRICS = 'overview_metrics',
  TV_BUDGET_TECH_CARD = 'tv_budget_tech_card',
  BUDGET_MEMBERS = 'budget_members',
  TV_METRICS = 'tv_metrics',
  TV_SCORECARD = 'tv_scorecard',
  TV_SCORES = 'tv_scores',
  TV_SYNTHESIS = 'tv_synthesis',
  TOPIC_SYNTHESIS = 'topic_synthesis',
  // TECH_REPORT_SECTIONS = 'tech_report_sections',
  // CLUSTERS = 'clusters',
  // DOC_CLUSTERS = 'doc_clusters',
  // CLUSTER_EMBEDDINGS = 'cluster_embeddings',
  // REPORT_TECHNOLOGY_OVERVIEW_DATA = 'report_technology_overview_data',
  // DOCUMENT_AGGREGATOR_DATA = 'document_aggregator_data',
  // EXAMPLE_MODULE_OUTPUT_DATA = 'example_module_output_data',
  // REPORT_GENERATOR_DATA = 'report_generator_data',
  // REPORT_GENERATOR_DATA_FOR_PDF = 'report_generator_data_for_pdf',
  // BUDGET_TECHS = 'tv_budget_techs',
}


export enum TvModuleStatus {
  QUEUED = 'QUEUED',
  PENDING = 'PENDING',
  RUNNING = 'RUNNING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  CANCEL_REQUESTED = 'CANCEL_REQUESTED',
  CANCELLED = 'CANCELLED',
  NOT_STARTED = 'NOT_STARTED',
  COMING_SOON = 'COMING_SOON'
}

export interface ITechVectorConfig {
  user_description: string;
  use_case: UseCaseValue;
  scope: Scope;
  reasoning_effort: ReasoningEffort;
  research_effort: ResearchEffort;
  search_strategy: SearchStrategy;
}


export interface ISuggestedTechVector {
  id: string;
  domain: string;
  title: string;
  description: string;
  tag: string;
  chips: string[];
  prompt: string;
  thumbnail_url: string;
  created_at: Date;
}

export interface TvManifestItem {
  filename: string;
  model_version: number;
  updated_at: number;
}
export interface TvManifest {
  tv_id: string;
  current_version_id: string;
  updated_at: number;
  datasets: {
    [K in TvDataset]: TvManifestItem
  }
}

export interface ISearchFromTopicsEnqueueResponse {
  success: true;
  job_id: string;
  queue_position: number;
  eta_seconds: number;
}

export interface ISearchQueueFullError {
  error: 'search_queue_full';
  message: string;
  queued: number;
  running: number;
}

export interface ISearchQueueStatus {
  queued: number;
  running: number;
  max_concurrency: number;
  capacity_available: boolean;
}

export type StartSearchFromTopicsOutcome =
  | { kind: 'enqueued'; response: ISearchFromTopicsEnqueueResponse }
  | { kind: 'queue_full'; error: ISearchQueueFullError };

export function formatSearchEnqueueDetail(
  response: ISearchFromTopicsEnqueueResponse,
): string {
  const parts: string[] = [];
  if (response.queue_position > 1) {
    parts.push(`Queue position: ${response.queue_position}`);
  }
  parts.push(`Estimated time: ~${response.eta_seconds}s`);
  return parts.join(' · ');
}

export function formatSearchQueueFullDetail(
  error: ISearchQueueFullError,
): string {
  return `${error.message} (${error.queued} queued, ${error.running} running). Try again in about a minute.`;
}

